import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const FACTOR_LABELS = { wage: "Faktor Upah", allowance: "Faktor Tunjangan", meal: "Faktor Uang Makan" };
const OPTIONS = [
  { v: "", l: "Belum diatur" },
  { v: "1", l: "100%" },
  { v: "0.75", l: "75%" },
  { v: "0.5", l: "50%" },
  { v: "0.25", l: "25%" },
  { v: "0", l: "0%" },
];
const toStr = (n) => (n === null || n === undefined ? "" : String(n));

export default function HrPaidDaysPolicy() {
  const { can } = useAuth();
  const canManage = can("hr.payroll.manage");
  const [meta, setMeta] = useState({ statuses: [], factor_keys: [] });
  const [factors, setFactors] = useState({});
  const [updated, setUpdated] = useState(null);

  const load = async () => {
    try {
      const r = (await api.get("/hr/payroll/paid-days-policy")).data;
      setMeta({ statuses: r.statuses, factor_keys: r.factor_keys });
      setFactors(r.factors || {});
      setUpdated(r.updated_at ? `${r.updated_at.slice(0, 10)} · ${r.updated_by || ""}` : null);
    } catch (e) { toast.error(apiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const setCell = (st, key, val) => setFactors((f) => ({ ...f, [st]: { ...(f[st] || {}), [key]: val === "" ? null : Number(val) } }));
  const save = async () => {
    try { await api.post("/hr/payroll/paid-days-policy", { factors }); toast.success("Kebijakan Hari Dibayar disimpan"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="p-6" data-testid="paid-days-policy-page">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h1 className="text-2xl font-semibold text-white">Kebijakan Hari Dibayar</h1>
          <p className="text-slate-400 text-sm max-w-3xl">Faktor pembayaran per status absensi untuk karyawan HARIAN. Diatur terpisah untuk komponen Upah, Tunjangan, dan Uang Makan. Kosong = <b>Belum diatur</b> (tidak diasumsikan). Tidak ada kebijakan SPH yang di-seed otomatis.</p>
          {updated && <p className="text-slate-500 text-xs mt-1">Terakhir diubah: {updated}</p>}
        </div>
        {canManage && <Button data-testid="save-policy-btn" onClick={save} className="bg-emerald-600 hover:bg-emerald-500">Simpan Kebijakan</Button>}
      </div>

      <Card className="p-0 bg-slate-900 border-slate-800 overflow-x-auto">
        <table className="w-full text-sm text-slate-300">
          <thead>
            <tr className="text-left text-slate-500 border-b border-slate-800">
              <th className="p-3">Status Absensi</th>
              {meta.factor_keys.map((k) => <th key={k} className="p-3">{FACTOR_LABELS[k] || k}</th>)}
            </tr>
          </thead>
          <tbody>
            {meta.statuses.map((st) => (
              <tr key={st} data-testid={`policy-row-${st}`} className="border-b border-slate-800">
                <td className="p-3 text-white">{st}</td>
                {meta.factor_keys.map((k) => {
                  const cur = toStr((factors[st] || {})[k]);
                  const unknown = !OPTIONS.some((o) => o.v === cur);
                  return (
                    <td key={k} className="p-3">
                      <select
                        data-testid={`policy-${st}-${k}`}
                        disabled={!canManage}
                        value={unknown ? cur : cur}
                        onChange={(e) => setCell(st, k, e.target.value)}
                        className="bg-slate-800 border border-slate-700 rounded px-2 py-1.5 text-sm text-white disabled:opacity-60">
                        {OPTIONS.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
                        {unknown && <option value={cur}>{Math.round(Number(cur) * 100)}%</option>}
                      </select>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      <p className="text-slate-500 text-xs mt-3">Contoh: Cuti bisa <b>Upah 100%</b> tetapi <b>Uang Makan 0%</b> (tidak hadir fisik). Perhitungan HARIAN: Upah = Upah Harian × Σ(Faktor Upah), Tunjangan = Tarif × Σ(Faktor Tunjangan), Uang Makan = Tarif × Σ(Faktor Uang Makan).</p>
    </div>
  );
}
